import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { ResponseCommonSI } from "@interfaces/services/common.interfaces";
import { BASE_URL, ENDPOINTS } from "@core/config/constants";
import { PersonTypeSI } from "@interfaces/services/persontype.interfaces";

@Injectable({
  providedIn: "root",
})
export class PersonTypeService {
  constructor(private _http: HttpClient) {}

  async getPersonType(): Promise<PersonTypeSI[]> {
    const result = await firstValueFrom<ResponseCommonSI<PersonTypeSI[]>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.PERSON_TYPE}`)
    );
    return result.payload;
  }
}
